export default {"src":"/_next/static/media/AMAT.bfc24eb6.svg","height":18,"width":18};